// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset.css */

/* use border-box for all elements */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* remove default margin */
body,
h1, h2, h3, h4, h5, h6,
p, figure, blockquote,
dl, dd {
  margin: 0;
}

/* remove padding and bullets from lists */
ul[role='list'],
ol[role='list'] {
  list-style: none;
  padding: 0;
}

/* ensure full height */
html, body {
  height: fit-content;
  scroll-behavior: smooth;
  scroll-padding-top: 120px;
}

/* improve text rendering */
body {
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  color: var(--color-contrast-dark-gray);
}

body:has(.menu--toggle[data-opened]) {
  pointer-events: none;
}

body::before {
  content: "";
  opacity: 0;
  transition: opacity ease-in 0.4s;
} 

body:has(.menu--toggle[data-opened])::before {
  width: 100vw;
  height: 100vh;
  background-color: #00000080;
  position: fixed;
  top: 5px;
  left: 0;
  opacity: 1;
  z-index: 9;
}

/* make media elements responsive */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* remove default styles from form elements */
input,
button,
textarea,
select {
  font: inherit;
}

/* remove default button styles */
button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

/* enable smooth scrolling */
html:focus-within {
  scroll-behavior: smooth;
}

/* remove default link styles */
a {
  text-decoration: none;
  color: inherit;
}

/* reduce motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global/reset.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,oCAAoC;AACpC;;;EAGE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;;;;EAIE,SAAS;AACX;;AAEA,0CAA0C;AAC1C;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,QAAQ;EACR,OAAO;EACP,UAAU;EACV,UAAU;AACZ;;AAEA,mCAAmC;AACnC;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;;;;EAIE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF","sourcesContent":["/* reset.css */\n\n/* use border-box for all elements */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* remove default margin */\nbody,\nh1, h2, h3, h4, h5, h6,\np, figure, blockquote,\ndl, dd {\n  margin: 0;\n}\n\n/* remove padding and bullets from lists */\nul[role='list'],\nol[role='list'] {\n  list-style: none;\n  padding: 0;\n}\n\n/* ensure full height */\nhtml, body {\n  height: fit-content;\n  scroll-behavior: smooth;\n  scroll-padding-top: 120px;\n}\n\n/* improve text rendering */\nbody {\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n  color: var(--color-contrast-dark-gray);\n}\n\nbody:has(.menu--toggle[data-opened]) {\n  pointer-events: none;\n}\n\nbody::before {\n  content: \"\";\n  opacity: 0;\n  transition: opacity ease-in 0.4s;\n} \n\nbody:has(.menu--toggle[data-opened])::before {\n  width: 100vw;\n  height: 100vh;\n  background-color: #00000080;\n  position: fixed;\n  top: 5px;\n  left: 0;\n  opacity: 1;\n  z-index: 9;\n}\n\n/* make media elements responsive */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* remove default styles from form elements */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* remove default button styles */\nbutton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n/* enable smooth scrolling */\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\n/* remove default link styles */\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n/* reduce motion for accessibility */\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  \n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
